import React, { useState } from 'react';
import './career.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Navbar from '../components/navbar';
import { Helmet } from "react-helmet";
import { form } from 'framer-motion/client';

export default function RecruitmentForm() {
  const isApplicationsOpen = false;
  const [step, setStep] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    grade: '',
    otherGrade: '',
    email: '',
    contactNumber: '',
    preferredPaths: [],
    otherPath: '',
    reason: '',
    skills: '',
    used_software: '',
    technicalSkillLevel: '',
    owned_equipment: '',
    worked_before: '',
    availability: '',
    involved_clubs: '',
    past_works: '',
    future_contributions: '',
    isTrue: ''
  });

  const [errors, setErrors] = useState({});
  const [otherPathVisible, setOtherPathVisible] = useState(false);
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;


    if (type === 'checkbox' && name === 'preferredPaths') {
      setFormData(prev => {
        const updatedList = checked
          ? [...prev.preferredPaths, value]
          : prev.preferredPaths.filter(item => item !== value);

        if (updatedList.includes('other')) {
          setOtherPathVisible(true);
        } else {
          setOtherPathVisible(false);
        }
        if (checked) {
          return {
            ...prev,
            [name]: [...prev[name], value]
          };
        } else {
          return {
            ...prev,
            [name]: prev[name].filter(item => item !== value)
          };
        }
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateStep1 = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    }

    if (!formData.grade) {
      newErrors.grade = 'Please select your grade';
    }
    if (!formData.grade && otherGradesVisible) {
      newErrors.otherGrade = 'Please specify your grade';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.contactNumber.trim()) {
      newErrors.contactNumber = 'Contact number is required';
    } else if (!/^[0-9]{10}$/.test(formData.contactNumber.replace(/\s+/g, ''))) {
      newErrors.contactNumber = 'Please enter a valid phone number';
    }

    if (!formData.preferredPaths) {
      newErrors.preferredPaths = 'Please select a preferred path';
    }

    if (formData.preferredPaths === 'other' && !formData.otherPath.trim()) {
      newErrors.otherPath = 'Please specify your preferred path';
    }

    if (!formData.reason.trim()) {
      newErrors.reason = 'Please tell us why you want to join';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};


    if (!formData.technicalSkillLevel) {
      newErrors.technicalSkillLevel = 'Please rate your technical skill level';
    }

    if (!formData.worked_before) {
      newErrors.worked_before = 'Please select an option';
    }

    if (!formData.availability) {
      newErrors.availability = 'Please select your availability';
    }

    if (!formData.involved_clubs.trim()) {
      newErrors.involved_clubs = 'Please answer this question';
    }

    if (!formData.past_works.trim() && !formData.future_contributions.trim()) {
      newErrors.past_works = 'Please provide past work links or describe future contributions';
    }

    if (!formData.isTrue) {
      newErrors.isTrue = 'Please confirm that all information is true';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep1()) {
      setStep(2);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handlePrevStep = () => {
    setStep(1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async () => {
    if (!validateStep2()) {
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch(process.env.REACT_APP_API_KEY, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      setStep(3);
    } catch (error) {
      alert('There was an error submitting your application. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className='career-container'>
        <Helmet>
          <title>Richmond Live | Recruitment</title>
          <meta property="og:title" content="Richmond Live | Recruitment" />
        </Helmet>
        <Navbar />
        <div className="container">
          <div>

            <div className="header">
              <h1 className="title">Join Richmond Live!</h1>
              <hr></hr>
              {step == 1 && (
                <>
                  <p className="description">
                    Calling for Applicants for ​Team Richmond Live, Sri Lanka’s premier school broadcasting crew!
                    <br /><br></br>
                    We are seeking creative students passionate about media, production, and design to join our team.
                    Please complete the form with accurate details. All applicants will be contacted for an interview.

                    <br></br>Apply now to join the Richmond Live family!

                  </p>
                </>
              )}

            </div>




            <div className="form-wrapper">
              <div className="form">
                {!isApplicationsOpen ? (
                  <div className="success-container">
                    <h2 className="success-title">Applications Closed</h2>
                    <p className="success-message">
                      New applications are currently closed. We appreciate your interest in Richmond Live!
                    </p>
                    <div className='contact-us'>
                      <p>
                        <span className="span-bold">For Inquiries</span>
                        If you have any questions, feel free to reach out:
                        <br />
                        +94 78 628 5636 (Chanuth)
                        <br />
                        <a href='mailto:info@richmondlive.lk'>info@richmondlive.lk</a>
                      </p>
                    </div>
                  </div>
                ) : (
                  <>
                    {step === 1 && (
                      <>
                        <div className="form-group">
                          <label htmlFor="fullName" className="label">Full Name *</label>
                          <input
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            className={`input ${errors.fullName ? 'input-error' : ''}`}
                          />
                          {errors.fullName && <span className="error-message">{errors.fullName}</span>}
                        </div>

                        <div className="form-group">
                          <label className="label">Grade (in 2026) or A/L year *</label>
                          <div className="radio-group">
                            {['2025 A/L', '2026 A/L', '2027 A/L', '2028 A/L', 'Other'].map((option) => (
                              <label key={option} className="radio-label">
                                <input
                                  type="radio"
                                  name="grade"
                                  value={option}
                                  checked={formData.grade === option}
                                  onChange={handleInputChange}
                                  className="radio-input"
                                />
                                <span className="radio-text">{option}</span>
                              </label>
                            ))}
                            {formData.grade == 'Other' && (
                              <div className="form-group">
                                <input
                                  type="text"
                                  id="otherGrade"
                                  name="otherGrade"
                                  value={formData.otherGrade}
                                  onChange={handleInputChange}
                                  className={`input ${errors.otherGrade ? 'input-error' : ''}`}
                                />
                                {errors.otherGrade && <span className="error-message">{errors.otherGrade}</span>}
                              </div>

                            )}
                          </div>
                          {errors.grade && <span className="error-message">{errors.grade}</span>}
                        </div>

                        <div className="form-group">
                          <label htmlFor="email" className="label">Email Address *</label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder='example@gmail.com'
                            value={formData.email}
                            onChange={handleInputChange}
                            className={`input ${errors.email ? 'input-error' : ''}`}
                          />
                          {errors.email && <span className="error-message">{errors.email}</span>}
                        </div>

                        <div className="form-group">
                          <label htmlFor="contactNumber" className="label">Contact Number (Whatsapp) *</label>
                          <input
                            type="tel"
                            id="contactNumber"
                            name="contactNumber"
                            value={formData.contactNumber}
                            onChange={handleInputChange}
                            className={`input ${errors.contactNumber ? 'input-error' : ''}`}
                            placeholder="0771234567"
                          />
                          {errors.contactNumber && <span className="error-message">{errors.contactNumber}</span>}
                        </div>

                        <div className="form-group">
                          <label className="label">Preferred Paths *</label>
                          <div className="radio-group">
                            {[
                              'Live Camera Crew',
                              'Video Editing/Motion Designing',
                              'Videography',
                              'Photography',
                              'Graphics Designing',
                              'Live Production',
                              'HR Team',
                              'Commentary',
                              'Scoring',
                              'Web/App Developing',
                              'other'
                            ].map((option) => (
                              <label key={option} className="radio-label">
                                <input
                                  type="checkbox"
                                  name="preferredPaths"
                                  value={option}
                                  checked={formData.preferredPaths.includes(option)}
                                  onChange={handleInputChange}
                                  className="radio-input"
                                />
                                <span className="radio-text">{option}</span>
                              </label>
                            ))}
                          </div>
                          {errors.preferredPaths && <span className="error-message">{errors.preferredPaths}</span>}
                        </div>

                        {otherPathVisible && (
                          <div className="form-group">
                            <label htmlFor="otherPath" className="label">Please specify your preferred path *</label>
                            <input
                              type="text"
                              id="otherPath"
                              name="otherPath"
                              value={formData.otherPath}
                              onChange={handleInputChange}
                              className={`input ${errors.otherPath ? 'input-error' : ''}`}
                              placeholder="Enter your preferred path"
                            />
                            {errors.otherPath && <span className="error-message">{errors.otherPath}</span>}
                          </div>
                        )}

                        <div className="form-group">
                          <label htmlFor="reason" className="label">Why do you want to join the Richmond Live team? *</label>
                          <textarea
                            id="reason"
                            name="reason"
                            value={formData.reason}
                            onChange={handleInputChange}
                            className={`input textarea ${errors.reason ? 'input-error' : ''}`}
                            rows="4"
                          />
                          {errors.reason && <span className="error-message">{errors.reason}</span>}
                        </div>

                        <button onClick={handleNextStep} className="submit-btn">
                          Next Step
                        </button>
                      </>
                    )}

                    {step === 2 && (
                      <>
                        <div className="form-group">
                          <label htmlFor="skills" className="label">What skills do you have related to media production? </label>
                          <textarea
                            id="skills"
                            name="skills"
                            value={formData.skills}
                            onChange={handleInputChange}
                            className={`input textarea ${errors.skills ? 'input-error' : ''}`}
                            placeholder="e.g., Camera operation, Video editing, Color grading..."
                            rows="3"
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="used_software" className="label">What software or tools have you used before? </label>
                          <input
                            type="text"
                            id="used_software"
                            name="used_software"
                            value={formData.used_software}
                            onChange={handleInputChange}
                            className={`input`}
                            placeholder="e.g., Adobe Premiere, Final Cut Pro, Photoshop..."
                          />
                        </div>

                        <div className="form-group">
                          <label className="label">How would you rate your technical skill level? *</label>
                          <div className="radio-group">
                            {['Beginner', 'Intermediate', 'Advanced', 'Expert'].map((option) => (
                              <label key={option} className="radio-label">
                                <input
                                  type="radio"
                                  name="technicalSkillLevel"
                                  value={option}
                                  checked={formData.technicalSkillLevel === option}
                                  onChange={handleInputChange}
                                  className="radio-input"
                                />
                                <span className="radio-text">{option}</span>
                              </label>
                            ))}
                          </div>
                          {errors.technicalSkillLevel && <span className="error-message">{errors.technicalSkillLevel}</span>}
                        </div>

                        <div className="form-group">
                          <label htmlFor="owned_equipment" className="label">Do you own or have access to any production equipment? </label>
                          <input
                            type="text"
                            id="owned_equipment"
                            name="owned_equipment"
                            value={formData.owned_equipment}
                            onChange={handleInputChange}
                            className={`input`}
                            placeholder="e.g., DSLR camera, editing laptop, drone, or 'None'"
                          />
                        </div>

                        <div className="form-group">
                          <label className="label">Have you worked on any video or livestream projects before? *</label>
                          <div className="radio-group">
                            {['Yes', 'No'].map((option) => (
                              <label key={option} className="radio-label">
                                <input
                                  type="radio"
                                  name="worked_before"
                                  value={option}
                                  checked={formData.worked_before === option}
                                  onChange={handleInputChange}
                                  className="radio-input"
                                />
                                <span className="radio-text">{option}</span>
                              </label>
                            ))}
                          </div>
                          {errors.worked_before && <span className="error-message">{errors.worked_before}</span>}
                        </div>

                        <div className="form-group">
                          <label className="label">How often are you available for school events and productions? *</label>
                          <div className="radio-group">
                            {['Always', 'Often', 'Occasionally', 'Rarely'].map((option) => (
                              <label key={option} className="radio-label">
                                <input
                                  type="radio"
                                  name="availability"
                                  value={option}
                                  checked={formData.availability === option}
                                  onChange={handleInputChange}
                                  className="radio-input"
                                />
                                <span className="radio-text">{option}</span>
                              </label>
                            ))}
                          </div>
                          {errors.availability && <span className="error-message">{errors.availability}</span>}
                        </div>

                        <div className="form-group">
                          <label htmlFor="involved_clubs" className="label">Have you been involved in any school clubs, sports or societies? *</label>
                          <input
                            type="text"
                            id="involved_clubs"
                            name="involved_clubs"
                            value={formData.involved_clubs}
                            onChange={handleInputChange}
                            className={`input ${errors.involved_clubs ? 'input-error' : ''}`}
                            placeholder="e.g., Drama club, Sports teams, or 'None'"
                          />
                          {errors.involved_clubs && <span className="error-message">{errors.involved_clubs}</span>}
                        </div>

                        <div className="form-group">
                          <label htmlFor="past_works" className="label">Please attach or link any of your past works if available</label>
                          <input
                            type="text"
                            id="past_works"
                            name="past_works"
                            value={formData.past_works}
                            onChange={handleInputChange}
                            className={`input ${errors.past_works ? 'input-error' : ''}`}
                            placeholder="Google Drive, YouTube, Instagram, or other links"
                          />
                          {errors.past_works && <span className="error-message">{errors.past_works}</span>}
                        </div>

                        <div className="form-group">
                          <label htmlFor="future_contributions" className="label">If you don't have previous work, tell us how you'd like to contribute *</label>
                          <textarea
                            id="future_contributions"
                            name="future_contributions"
                            value={formData.future_contributions}
                            onChange={handleInputChange}
                            className="input textarea"
                            placeholder="Describe how you plan to contribute to Richmond Live..."
                            rows="3"
                          />
                        </div>

                        <div className="form-group">
                          <label className="label">Confirmation *</label>
                          <div className="checkbox-group">
                            <label className="checkbox-label">
                              <input
                                type="checkbox"
                                name="isTrue"
                                value="true"
                                checked={formData.isTrue === "true"}
                                onChange={(e) => handleInputChange({ target: { name: 'isTrue', value: e.target.checked ? 'true' : '' } })}
                                className="checkbox-input"
                              />
                              <span className="checkbox-text">I confirm that all the information provided is true and that I'm genuinely interested in joining the Richmond Live Team.</span>
                            </label>
                          </div>
                          {errors.isTrue && <span className="error-message">{errors.isTrue}</span>}
                        </div>

                        <div className="button-group">
                          <button onClick={handlePrevStep} className="back-btn" disabled={submitting}>
                            Back
                          </button>
                          <button onClick={handleSubmit} className="submit-btn" disabled={submitting}>
                            {submitting ? 'Submitting...' : 'Submit Application'}
                          </button>
                        </div>
                      </>
                    )}

                    {step === 3 && (
                      <div className="success-container">
                        <div className="success-icon">
                          <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="40" cy="40" r="38" stroke="url(#successGradient)" strokeWidth="4" />
                            <path d="M25 40L35 50L55 30" stroke="url(#successGradient)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                            <defs>
                              <linearGradient id="successGradient" x1="0" y1="0" x2="80" y2="80">
                                <stop offset="0%" stopColor="#ff4757" />
                                <stop offset="100%" stopColor="#e84393" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </div>
                        <h2 className="success-title">Application Submitted Successfully!</h2>
                        <p className="success-message">
                          Thank you for applying Richmond Live. We have received your application. Our team will review it and get back to you soon.
                        </p>
                        <p className="success-note">
                          You will receive a confirmation email at <strong>{formData.email}</strong> within 24 hours. Please check your inbox and spam folder.
                          <br />
                          <a href='https://chat.whatsapp.com/JfStGbVYpylHdnKTjQZEtu' className='whatsapp-link' target='_blank' rel='noopener noreferrer'>Join our WhatsApp group</a>
                        </p>

                        <button onClick={() => {
                          setStep(1);
                          setFormData({
                            fullName: '',
                            grade: '',
                            email: '',
                            contactNumber: '',
                            preferredPaths: '',
                            otherPath: '',
                            reason: '',
                            skills: '',
                            used_software: '',
                            technicalSkillLevel: '',
                            owned_equipment: '',
                            worked_before: '',
                            availability: '',
                            involved_clubs: '',
                            past_works: '',
                            future_contributions: '',
                            isTrue: ''
                          });
                          setErrors({});
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }} className="restart-btn">
                          Submit Another Application
                        </button>
                        <div className='contact-us'>
                          <p>
                            <span className="span-bold">For Inquiries</span>
                            If you have any questions about the recruitment or the team, feel free to reach out:
                            <br />
                            +94 78 628 5636 (Chanuth)
                            <br />
                            <a href='mailto:info@richmondlive.lk'>info@richmondlive.lk</a>
                          </p>
                        </div>
                      </div>

                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
